<template>
  <div class="step-consultation">
    <div class="flex flex-col">
      <div class="navbar-menu consultation-question-nav step-questions-nav" v-if="!hideSecondaryBar">
        <div class="container">
          <div class="left-section flex-1" v-if="consultationStatus === 'Questionnaire'">
            <div
              class="step-previous-question"
              v-on:click="prev"
              v-if="!isDe || (isDe && usCurrentQuestionPosition !== 1)"
            >
              <amp-img
                class="hidden-xs"
                noloading="noloading"
                :src="'/resources/img/icons/' + arrowColor + '_left_arrow.webp'"
                alt="Back"
                width="26"
                height="16"
              >
                <amp-img
                  noloading="noloading"
                  :src="'/resources/img/icons/' + arrowColor + '_left_arrow.png'"
                  alt="Back"
                  width="26"
                  height="16"
                  fallback="fallback"
                ></amp-img>
              </amp-img>
              <amp-img
                class="hidden visible-xs"
                noloading="noloading"
                :src="'/resources/img/icons/' + mobileArrowColor + '_left_arrow.webp'"
                alt="Back"
                width="26"
                height="16"
              >
                <amp-img
                  noloading="noloading"
                  :src="'/resources/img/icons/' + mobileArrowColor + '_left_arrow.png'"
                  alt="Back"
                  width="26"
                  height="16"
                  fallback="fallback"
                ></amp-img>
              </amp-img>
              <p class="hidden-xs">{{ isDe ? "Vorherige Frage" : "Previous Question" }}</p>
            </div>
          </div>
          <div
            class="secure center-section"
            v-if="consultationStatus === 'SplashScreen'"
            v-bind:class="{ 'flex-col items-center w-full': this.isRocketRx }"
          >
            <div class="hidden-xs">
              <p>Ordered {{ reOrderInformation.productName }} before?</p>
              <a :href="reOrderInformation.repeatQuestionUrl">Pre-fill consultation now</a>
            </div>
            <div class="hidden visible-xs">
              <div>
                <p>Ordered {{ reOrderInformation.productName }} before?</p>
                <a :href="reOrderInformation.repeatQuestionUrl">Pre-fill consultation now</a>
              </div>
            </div>
          </div>
          <div class="secure center-section" v-else>
            <div class="text-primary md:text-white question-index" v-if="isDe" :key="usCurrentQuestionPosition">
              Frage {{ usCurrentQuestionPosition.toString() }} von {{ totalQuestions }}
            </div>
            <div class="text-primary md:text-white question-index" v-if="!isDe">
              Question {{ usCurrentQuestionPosition }} of {{ totalQuestions }}
            </div>
          </div>
          <div class="flex-1" />
        </div>
      </div>
      <div class="consultation-pg-bar" :class="appTheme === 'levity' ? 'order-first' : ''">
        <div
          class="current-progress"
          :style="{
            width:
              consultationStatus === 'SplashScreen'
                ? '0%'
                : (usCurrentQuestionPosition / parseFloat(totalQuestions)) * 100 + '%',
          }"
        />
      </div>
    </div>
    <div class="container question-holder">
      <div class="row">
        <div class="col-md-12">
          <div>
            <template v-if="consultationStatus === 'SplashScreen'">
              <ConsultationStartScreenStepsLeft
                v-if="
                  !isWeightLossConsultation &&
                  !isWeightLossInjectableSixMonthlyReviewCheckIn &&
                  !isWeightLossInjectableSideEffectsConsultation &&
                  !isDe
                "
                :start="start"
                :trigger-live-chat="triggerLiveChat"
                :steps="consultationStartScreenSteps"
                :steps-count="consultationStartScreenStepsCount"
                :theme="appTheme"
              />
              <ConsultationStartScreenAgreement
                v-if="
                  isWeightLossConsultation && !isCheckInConsultation && !isWeightLossInjectableSideEffectsConsultation
                "
                :start="start"
                :startScreenAgreement="startScreenAgreement"
                :company-name="companyName"
                :theme="appTheme"
              />

              <CheckInConsultationStartScreenLevity
                v-if="isWeightLossConsultation && isCheckInConsultation"
                :start="start"
              />

              <WeightLossSideEffectsConsultationStartScreen
                v-if="!isWeightLossConsultation && isWeightLossInjectableSideEffectsConsultation"
                :start="start"
              />
              <WeightLossInjectableSixMonthlyReviewCheckInStartScreen
                v-if="!isWeightLossConsultation && isWeightLossInjectableSixMonthlyReviewCheckIn"
                :start="start"
              />
            </template>

            <div
              v-if="consultationStatus === 'Questionnaire'"
              class="step-questions"
              :class="{
                'step-questions--tight': appTheme === 'rocketrx' && onLastQuestion,
                'max-sm:mb-[100px]': shouldShowStickyNextButton,
              }"
            >
              <template v-for="question in currentQuestionAsArray">
                <StateQuestion
                  :key="question.id"
                  v-if="question.questionType === 'StateQuestion'"
                  :states="states"
                  :initial-selected-state-key="usShippingState"
                  v-on:next="submitStateQuestion"
                />
                <SimpleBmiQuestion
                  v-if="question.questionType === 'SimpleBmiQuestion'"
                  :question="question"
                  :measurement-systems="availableMeasurementSystems"
                  :weight-input-style="weightInputStyle"
                  :height-input-style="heightInputStyle"
                  :key="question.id"
                  v-on:update-next-button-status="updateNextButtonStatus"
                />
                <WeightQuestion
                  v-if="question.questionType === 'WeightQuestion'"
                  :question="question"
                  :measurement-systems="availableMeasurementSystems"
                  :weight-input-style="weightInputStyle"
                  :key="question.id"
                  v-on:update-next-button-status="updateNextButtonStatus"
                />

                <MultipleChoiceQuestion
                  v-if="
                    question.questionType === 'YesNoQuestion' ||
                    question.questionType === 'WarningQuestion' ||
                    question.questionType === 'MedicineRestrictionQuestion' ||
                    question.questionType === 'SingleSelectQuestion' ||
                    question.questionType === 'SingleSelectWithFreeTextQuestion' ||
                    question.questionType === 'EthnicityQuestion'
                  "
                  :key="question.id"
                  :question="question"
                  :show-required="showRequired"
                  :first="true"
                  :validate="false"
                  v-on:answer="updateAnswer"
                  v-on:validation="updateValidation"
                  v-on:update-next-button-status="updateNextButtonStatus"
                  v-on:next="next"
                />

                <MultiSelectQuestion
                  v-if="
                    question.questionType === 'MultiSelectQuestion' || question.questionType === 'ComorbiditiesQuestion'
                  "
                  :key="question.id"
                  :question="question"
                  :show-required="showRequired"
                  v-on:answer="updateAnswer"
                  v-on:update-next-button-status="updateNextButtonStatus"
                />

                <FreeTextMedicalQuestion
                  v-if="question.questionType === 'FreeTextMedicalQuestion'"
                  :key="question.id"
                  :question="question"
                  :show-required="showRequired"
                  :first="true"
                  :validate="false"
                  :hasDefaultAnswer="question.response != null"
                  v-on:answer="updateAnswer"
                  v-on:validation="updateValidation"
                  v-on:any-input-changed="updateShowRequired"
                  v-on:next="next"
                  v-on:update-next-button-status="updateNextButtonStatus"
                />

                <FreeTextQuestion
                  v-if="question.questionType === 'FreeTextQuestion'"
                  :key="question.id"
                  :question="question"
                  v-on:answer="updateAnswer"
                  v-on:update-next-button-status="updateNextButtonStatus"
                />

                <CustomFreeTextMedicalQuestion
                  v-if="question.questionType === 'CustomFreeTextMedicalQuestion'"
                  :key="question.id"
                  :question="question"
                  :show-required="showRequired"
                  :first="true"
                  :validate="false"
                  :hasDefaultAnswer="question.response != null"
                  v-on:answer="updateAnswer"
                  v-on:validation="updateValidation"
                  v-on:yesno-input-changed="updateShowRequired"
                  v-on:next="next"
                  v-on:update-next-button-status="updateNextButtonStatus"
                />

                <MedicalQuestion
                  v-if="question.questionType === 'MedicalQuestion'"
                  :key="question.id"
                  :question="question"
                  :show-required="showRequired"
                  :first="true"
                  :validate="false"
                  :hasDefaultAnswer="question.response != null"
                  v-on:answer="updateAnswer"
                  v-on:validation="updateValidation"
                  v-on:any-input-changed="updateShowRequired"
                  v-on:next="next"
                  v-on:update-next-button-status="updateNextButtonStatus"
                />

                <PhotoUploadQuestion
                  v-if="question.questionType === 'PhotoUploadQuestion'"
                  :key="question.id"
                  :question="question"
                  :show-required="showRequired"
                  :hasDefaultAnswer="question.response != null"
                  v-on:answer="updateAnswer"
                  v-on:validation="updateValidation"
                  v-on:any-input-changed="updateShowRequired"
                  v-on:next="next"
                  v-on:update-next-button-status="updateNextButtonStatus"
                />

                <BloodPressureRangeQuestion
                  v-if="question.questionType === 'BloodPressureQuestion'"
                  :key="question.id"
                  :question="question"
                  :show-required="showRequired"
                  :first="currentQuestionIndex === 0"
                  no-reading-redirect="/consultations/blood-pressure-check-needed"
                  v-on:answer="updateAnswer"
                  v-on:validation="updateValidation"
                  v-on:update-next-button-status="updateNextButtonStatus"
                  v-on:next="next"
                />

                <PreviousMigraineTreatmentQuestion
                  v-if="question.questionType === 'PreviousMigraineTreatmentQuestion'"
                  :key="question.id"
                  :question="question"
                  :show-required="showRequired"
                  :first="currentQuestionIndex === 0"
                  :bmi-information="bmiInformation"
                  v-on:answer="updateAnswer"
                  v-on:validation="updateValidation"
                  v-on:recent-reading-changed="updateShowRequired"
                  v-on:update-next-button-status="updateNextButtonStatus"
                />

                <DateQuestion
                  v-if="question.questionType === 'DateQuestion'"
                  :key="question.id"
                  :question="question"
                  :show-required="showRequired"
                  :first="currentQuestionIndex === 0"
                  v-on:validation="updateValidation"
                />

                <AgreementQuestion
                  v-if="onLastQuestion && question.questionType === 'AgreementQuestion'"
                  :show-comment="!hideAgreementComment"
                  :theme="appTheme"
                  :key="question.id"
                  :host-name-with-schema="hostNameWithSchema"
                  :show-required="showAcceptTermsRequired"
                  :question="question"
                  :accept-terms="acceptTerms"
                  :is-check-in-consultation="isCheckInConsultation"
                  v-on:validation="updateValidation"
                  v-on:submit="submit"
                />

                <DateOfBirthQuestion
                  v-if="question.questionType === 'DateOfBirthQuestion'"
                  :key="question.id"
                  :question="question"
                  :show-required="true"
                  v-on:validation="updateValidation"
                  v-on:answer="updateAnswer"
                  v-on:update-next-button-status="updateNextButtonStatus"
                />

                <div
                  class="step-questions-actions"
                  v-if="showNextButton && !onLastQuestion"
                  :key="question.id + '_actions'"
                  v-bind:class="{
                    'max-sm:fixed max-sm:bottom-[20px] max-sm:w-full max-sm:left-0 max-sm:pl-[20px] max-sm:pr-[20px]':
                      shouldShowStickyNextButton,
                  }"
                >
                  <button v-on:click="next()" class="next-question" :class="errorStateClass" type="button">
                    {{ isDe ? "Weiter" : "Next question" }}
                    <amp-img
                      noloading="noloading"
                      class="share-icons"
                      :src="rightArrowSrc"
                      alt=""
                      :width="rightArrowWidth"
                      :height="rightArrowHeight"
                    />
                  </button>
                </div>
              </template>

              <div class="step-questions-actions" v-if="consultationSubmissionButtonVisible">
                <button v-on:click="submit()" class="next-question" type="button">
                  {{ isDe ? "Einreichen" : "Submit" }}
                  <amp-img
                    noloading="noloading"
                    class="share-icons"
                    :src="rightArrowSrc"
                    alt=""
                    :width="rightArrowWidth"
                    :height="rightArrowHeight"
                  />
                </button>
              </div>

              <div v-if="errorMessage" aria-live="polite" class="ui-message ui-message-error ui-widget ui-corner-all">
                <span class="ui-message-error-icon"></span>
                <span class="ui-message-error-detail" v-html="errorMessage" />
              </div>
            </div>

            <div v-if="consultationStatus === 'NeedsBloodPressure'" class="step-questions-no-blood-pressure">
              <div class="no-blood-pressure-title">
                We can't treat you at the moment, but let's find somewhere nearby to get a free blood pressure reading.
              </div>
              <div class="no-blood-pressure-description">
                Leave your details below and we'll be in touch soon. After you've had your blood pressure tested, come
                back to continue your consultation.
              </div>

              <div class="no-blood-pressure-email">
                <label class="no-blood-pressure-email-label">Email address</label>
                <input type="text" class="no-blood-pressure-email-input" />
              </div>
              <div class="no-blood-pressure-zipcode">
                <label class="no-blood-pressure-zipcode-label">Zip code</label>
                <input type="text" class="no-blood-pressure-zipcode-input" />
              </div>

              <button class="no-blood-pressure-submit" type="button" v-on:click="submitContact">Submit details</button>
            </div>

            <div v-if="consultationStatus === 'ComeBackLater'" class="step-questions-contact-submitted">
              <amp-img
                noloading="noloading"
                class="share-icons step-questions-contact-submitted-logo"
                src="/resources/img/icons/thankyou.svg"
                alt=""
                width="60"
                height="60"
              />
              <div class="step-questions-contact-submitted-title">Thank you</div>
              <div class="step-questions-contact-submitted-description">
                We'll get back to you as soon as possible so you can continue with your consultation later
              </div>
              <button
                class="step-questions-contact-submitted-back"
                type="button"
                onclick="window.location.href='/'"
                v-text="'Back to homepage'"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import Vue, { PropType } from "vue";
import axios from "axios";

import poster from "../mixins/poster";

import responseAdapters from "../mixins/responseAdapters";
import responseWarningAdapters from "../mixins/responseWarningAdapters";
import extractConsultation from "../mixins/extractConsultation";
import formatName from "../mixins/formatName";
import { formatResponse } from "../mixins/formatResponse";

import ConsultationStartScreenStepsLeft from "./components/ConsultationStartScreenStepsLeft";
import ConsultationStartScreenAgreement from "./components/ConsultationStartScreenAgreement";
import CheckInConsultationStartScreenLevity from "./components/CheckInConsultationStartScreenLevity";
import WeightLossInjectableSixMonthlyReviewCheckInStartScreen from "./components/WeightLossInjectableSixMonthlyReviewCheckInStartScreen";
import WeightLossSideEffectsConsultationStartScreen from "./components/WeightLossSideEffectsConsultationStartScreen";
import FreeTextMedicalQuestion from "../components/FreeTextMedicalQuestion.vue";
import PreviousMigraineTreatmentQuestion from "../components/PreviousMigraineTreatmentQuestion.vue";
import CustomFreeTextMedicalQuestion from "../components/CustomFreeTextMedicalQuestion.vue";
import FreeTextQuestion from "../components/FreeTextQuestion/FreeTextQuestion.vue";
import MultipleChoiceQuestion from "../components/MultipleChoiceQuestion/MultipleChoiceQuestion.vue";
import MultiSelectQuestion from "../components/MultiSelectQuestion/MultiSelectQuestion.vue";
import MedicalQuestion from "../components/MedicalQuestion.vue";
import SimpleBmiQuestion from "../components/SimpleBmiQuestion";
import WeightQuestion from "../components/WeightQuestion";
import BloodPressureRangeQuestion from "../components/BloodPressureRangeQuestion";
import AgreementQuestion from "../components/AgreementQuestion";
import PhotoUploadQuestion from "../components/PhotoUploadQuestion/PhotoUploadQuestion.vue";
import StateQuestion, { State } from "../components/StateQuestion/StateQuestion.vue";
import DateQuestion from "../components/DateQuestion.vue";
import DateOfBirthQuestion from "../components/DateOfBirthQuestion/DateOfBirthQuestion.vue";

import {
  AnyQuestion,
  HeightInputStyleProps,
  MeasurementSystem,
  MultiSelectQuestion as IMultiSelectQuestion,
  Question,
  Questionnaire,
  QuestionnaireSection,
  StartScreenAgreement,
  WeightInputStyleProps,
} from "../types";
import { addLoadPageEvent, addUserProperties, amplitudeEvent } from "@/MXPixel/MedexpressAmplitude";

import "../../../stylesheets/common/tailwind.css";

import experiment from "amplitude-experiment";

interface LatestAnswer {
  question?: Question;
  data?: any;
}

interface StepConsultationProvide {
  isUs: boolean;
  isUk: boolean;
  isRocket: boolean;
  submitUrl: string;
  csrf: string;
  csrfHeader: string;
}

type ConsultationStatus = "SplashScreen" | "StateQuestion" | "Questionnaire" | "NeedsBloodPressure" | "ComeBackLater";

interface StepConsultationData {
  acceptTerms: boolean;
  valid: { [keys: number]: boolean };
  latestAnswer: LatestAnswer;
  showRequired: boolean;
  errorMessage: string | null;
  currentSectionIndex: number;
  currentQuestionIndex: number;
  consultationStatus: ConsultationStatus;
  showNextButton: boolean;
  errorState: boolean;
  numberOfPreviousHistoryItems: number;
  usShippingState: string | null;
  responseExtractors: any;
  responseWarningExtractors: any;
}

interface QuestionnaireResponse {
  responses: { [key: number]: any };
  acceptTerms: boolean;
  followUpRequestId?: number;
  usShippingState?: string;
}

export default Vue.extend({
  mixins: [poster],
  components: {
    ConsultationStartScreenStepsLeft,
    ConsultationStartScreenAgreement,
    CheckInConsultationStartScreenLevity,
    PhotoUploadQuestion,
    AgreementQuestion,
    SimpleBmiQuestion,
    WeightQuestion,
    BloodPressureRangeQuestion,
    FreeTextMedicalQuestion,
    FreeTextQuestion,
    PreviousMigraineTreatmentQuestion,
    CustomFreeTextMedicalQuestion,
    MultipleChoiceQuestion,
    MultiSelectQuestion,
    MedicalQuestion,
    StateQuestion,
    DateQuestion,
    DateOfBirthQuestion,
    WeightLossInjectableSixMonthlyReviewCheckInStartScreen,
    WeightLossSideEffectsConsultationStartScreen,
  },
  props: {
    followUpRequestId: {
      type: Number,
      required: false,
    },
    questionnaire: {
      type: Object as PropType<Questionnaire>,
      required: true,
    },
    bmiInformation: {
      type: Object as PropType<any>,
      required: false,
    },
    appTheme: {
      type: String,
      required: true,
    },
    analyticsData: {
      type: Object as PropType<any>,
      required: true,
    },
    analyticsFilledIn: {
      type: String,
      required: true,
    },
    submitUrl: {
      type: String,
      required: true,
    },
    productCode: {
      type: String,
      required: false,
    },
    hostNameWithSchema: {
      type: String,
      required: true,
    },
    reOrderInformation: {
      type: Object as PropType<{
        repeatQuestionUrl: string;
        productName: string;
      }>,
      required: false,
      default: undefined,
    },
    showReOrderBanner: {
      type: Boolean,
      required: true,
    },
    showStateQuestion: {
      type: Boolean,
      required: true,
    },
    csrf: {
      type: String,
      required: true,
    },
    csrfHeader: {
      type: String,
      required: true,
    },
    states: {
      type: Array as PropType<State[]>,
    },
    subscriptionId: {
      type: Number,
      required: false,
    },
    treatmentTypeConsultation: {
      type: String,
      required: false,
    },
    skipSplashScreen: {
      type: Boolean,
      required: false,
    },
    availableMeasurementSystems: {
      type: Array as PropType<MeasurementSystem[]>,
      required: true,
    },
    productCategoryReference: {
      type: String,
      required: true,
    },
    companyName: {
      type: String,
      required: true,
    },
  },
  data(): StepConsultationData {
    return {
      acceptTerms: process.env.APP_THEME === "rocketrx",
      valid: {},
      latestAnswer: {},
      showRequired: false,
      errorMessage: null,
      currentSectionIndex: 0,
      currentQuestionIndex: 0,
      consultationStatus: "SplashScreen",
      showNextButton: false,
      errorState: false,
      numberOfPreviousHistoryItems: 0,
      usShippingState: null,
      responseExtractors: {
        YesNoQuestion: responseAdapters.multipleChoice,
        AgreementQuestion: responseAdapters.multipleChoice,
        WarningQuestion: responseAdapters.multipleChoice,
        MedicineRestrictionQuestion: responseAdapters.multipleChoice,
        SimpleBmiQuestion: responseAdapters.simpleBmi,
        WeightQuestion: responseAdapters.weight,
        MultiSelectQuestion: responseAdapters.multiSelect,
        ComorbiditiesQuestion: responseAdapters.multiSelect,
        FreeTextMedicalQuestion: responseAdapters.freeTextMedical,
        FreeTextQuestion: responseAdapters.freeText,
        CustomFreeTextMedicalQuestion: responseAdapters.customFreeTextMedical,
        MedicalQuestion: responseAdapters.medical,
        BloodPressureQuestion: responseAdapters.bloodPressureRange,
        PreviousMigraineTreatmentQuestion: responseAdapters.previousMigraineTreatment,
        SingleSelectQuestion: responseAdapters.multipleChoice,
        SingleSelectWithFreeTextQuestion: responseAdapters.multipleChoice,
        PhotoUploadQuestion: responseAdapters.photoUpload,
        DateOfBirthQuestion: responseAdapters.date,
        EthnicityQuestion: responseAdapters.multipleChoice,
      },
      responseWarningExtractors: {
        YesNoQuestion: responseWarningAdapters.noWarning,
        AgreementQuestion: responseWarningAdapters.noWarning,
        WarningQuestion: responseWarningAdapters.noWarning,
        MedicineRestrictionQuestion: responseWarningAdapters.noWarning,
        SimpleBmiQuestion: responseWarningAdapters.noWarning,
        WeightQuestion: responseWarningAdapters.noWarning,
        MultiSelectQuestion: responseWarningAdapters.multiSelect,
        ComorbiditiesQuestion: responseWarningAdapters.multiSelect,
        FreeTextMedicalQuestion: responseWarningAdapters.freeTextMedical,
        FreeTextQuestion: responseWarningAdapters.noWarning,
        CustomFreeTextMedicalQuestion: responseWarningAdapters.customFreeTextMedical,
        MedicalQuestion: responseWarningAdapters.noWarning,
        BloodPressureQuestion: responseWarningAdapters.noWarning,
        PreviousMigraineTreatmentQuestion: responseWarningAdapters.noWarning,
        SingleSelectQuestion: responseWarningAdapters.noWarning,
        SingleSelectWithFreeTextQuestion: responseWarningAdapters.noWarning,
        PhotoUploadQuestion: responseWarningAdapters.photoUpload,
        DateOfBirthQuestion: responseWarningAdapters.noWarning,
        EthnicityQuestion: responseWarningAdapters.noWarning,
      },
    };
  },
  provide(): StepConsultationProvide {
    return {
      isUs: true,
      isUk: false,
      isRocket: process.env.APP_THEME === "rocketrx",
      submitUrl: this.submitUrl,
      csrf: this.csrf,
      csrfHeader: this.csrfHeader,
    };
  },
  created() {
    const searchParams = new URLSearchParams(window.location.search);
    const usState = searchParams.get("usState");
    if (usState) {
      this.usShippingState = usState;
    }

    addLoadPageEvent("Consultation Loaded", {
      ...this.analyticsData,
      "Has Saved Answers": this.analyticsFilledIn,
      "Consultation Type": this.treatmentTypeConsultation,
    });

    addUserProperties({
      ShowStateQuestion: this.showStateQuestion,
    });

    window.addEventListener("DOMContentLoaded", () => {
      this.synchronizeWithHistoryAPI();
      this.showCurrentScreenBasedOnUrl();
    });

    window.addEventListener("popstate", () => {
      this.restartConsultationIfUnansweredQuestions();
      this.synchronizeWithHistoryAPI();
      this.showCurrentScreenBasedOnUrl();
    });
    if (this.skipSplashScreen || this.shouldSkipSplashScreenDuringEdConsultation) {
      amplitudeEvent("Skip Splash Screen");
      this.start();
    }

    this.restartConsultationIfUnansweredQuestions();
  },
  computed: {
    mobileArrowColor(): string {
      if (this.appTheme === "rocketrx") {
        return "white";
      }

      if (this.appTheme === "levity") {
        return "black";
      }

      return "blue";
    },
    arrowColor(): string {
      if (this.appTheme === "levity") {
        return "black";
      }

      return "white";
    },
    rightArrowSrc(): string {
      // `black_right_arrow.svg` is the same as `@/ComponentLibrary/assets/arrow_right.svg` and is for levity theme
      return `/resources/img/icons/${this.arrowColor}_right_arrow.svg`;
    },
    // Remember to apply any changes here to AgreementQuestion.vue as well
    rightArrowWidth(): number {
      return this.appTheme !== "levity" ? 26 : 24;
    },
    // Remember to apply any changes here to AgreementQuestion.vue as well
    rightArrowHeight(): number {
      return this.appTheme !== "levity" ? 16 : 24;
    },
    totalQuestions(): number {
      return this.allQuestions.length;
    },
    showAcceptTermsRequired(): boolean {
      return this.showRequired && !this.acceptTerms;
    },
    onLastQuestion(): boolean {
      return this.totalQuestions - 1 === this.currentQuestionIndex;
    },
    sections(): QuestionnaireSection[] {
      return Object.values(this.questionnaire.questions);
    },
    usCurrentQuestionPosition(): number {
      let currentQuestionPosition = 0;
      // sum up the total number of questions in previous sections
      for (let index = 0; index < this.currentSectionIndex; index++) {
        currentQuestionPosition += this.sections[index].questions.length;
      }

      currentQuestionPosition += this.currentQuestionIndex + 1;
      return currentQuestionPosition;
    },
    errorStateClass(): string {
      return this.errorState ? "error-state" : "";
    },
    allQuestions(): AnyQuestion[] {
      if (this.showStateQuestion) {
        return [
          {
            id: -1,
            questionType: "StateQuestion",
          },
          ...this.questionnaire.allQuestions,
        ];
      }
      return this.questionnaire.allQuestions;
    },
    currentQuestionAsArray(): AnyQuestion[] {
      const index = this.currentQuestionIndex;
      return this.allQuestions.slice(index, index + 1);
    },
    consultationStartScreenSteps(): Array<string> {
      return this.appTheme === "rocketrx"
        ? ["Quick health questions", "Choose your treatment", "Review and pay"]
        : [
            "Answer a few quick health questions.",
            "Choose your treatment and confirm your ID.",
            "Review and pay for your order.",
          ];
    },
    consultationStartScreenStepsCount(): string {
      return "three";
    },
    hideSecondaryBar(): boolean {
      const isDeSplashScreen = this.isDe && this.consultationStatus === "SplashScreen";
      const isLevitySplashScreen = this.consultationStatus === "SplashScreen" && this.appTheme === "levity";
      const isSplashScreenWithoutReOrderBannerOrInfo =
        this.consultationStatus === "SplashScreen" && (!this.showReOrderBanner || !this.reOrderInformation);

      return isLevitySplashScreen || isSplashScreenWithoutReOrderBannerOrInfo || isDeSplashScreen;
    },
    consultationSubmissionButtonVisible(): boolean {
      const question = this.getCurrentQuestion();

      const questionType = question.questionType;

      return this.onLastQuestion && questionType != "AgreementQuestion";
    },
    isCheckInConsultation(): boolean {
      return !!this.subscriptionId;
    },
    isUk() {
      return process.env.REGION == "uk";
    },
    isDe() {
      return process.env.REGION == "de";
    },
    isRocketRx() {
      return this.appTheme === "rocketrx";
    },
    shouldShowStickyNextButton() {
      return experiment.variant("sticky-consultation-button-on-mobile").value === "variant";
    },
    usStartScreenAgreement(): StartScreenAgreement {
      return {
        title: "This bit's important",
        body: "Before starting your online consultation, please confirm that you:",
        agreements: [
          "<strong>Are answering for yourself, truthfully</strong>",
          "<strong>Have already tried diet and exercise to lose weight</strong>",
          "<strong>Will be the sole user of any treatment</strong>",
          "<strong>Are over 18 years old</strong>",
        ],
        showTermsAndConditions: true,
      };
    },
    ukStartScreenAgreement(): StartScreenAgreement {
      return {
        title: "Do you agree to the following?",
        body: null,
        agreements: [
          "I will answer honestly and on my own behalf.",
          "I will tell you about any medical conditions I have, and medication I take.",
          "I have tried to lose weight with lifestyle changes, including a healthy diet and exercise.",
          "I am <strong>not</strong> trying to get pregnant, and don’t have plans to in the next 3 months.",
          "I am <strong>not</strong> pregnant or breastfeeding.",
        ],
        showTermsAndConditions: false,
      };
    },
    shouldSkipSplashScreenDuringEdConsultation(): boolean {
      if (this.appTheme !== "rocketrx") {
        return false;
      }

      return !this.productCode.includes("finasteride");
    },
    isWeightLossConsultation(): boolean {
      return this.productCategoryReference == "weight-loss" || this.appTheme === "levity";
    },
    isWeightLossInjectableSixMonthlyReviewCheckIn(): boolean {
      return this.treatmentTypeConsultation == "WEIGHT_LOSS_INJECTABLE_SIX_MONTHLY_REVIEW_CHECK_IN";
    },
    isWeightLossInjectableSideEffectsConsultation(): boolean {
      return this.treatmentTypeConsultation == "WEIGHT_LOSS_INJECTABLE_SIDE_EFFECTS";
    },
    startScreenAgreement(): StartScreenAgreement {
      if (this.isUk || this.appTheme === "ziphealth") {
        return this.ukStartScreenAgreement;
      }

      return this.usStartScreenAgreement;
    },
    hideAgreementComment(): boolean {
      return (
        this.theme === "levity" ||
        this.isWeightLossInjectableSixMonthlyReviewCheckIn ||
        this.isWeightLossInjectableSideEffectsConsultation
      );
    },
    weightInputStyle(): WeightInputStyleProps {
      return {
        inputStyle: "w-[100px] p-4 rounded-xl",
        measurementIndicators: {
          imperial: {
            stone: {
              label: "st",
              placeholder: "stone",
            },
            pounds: {
              label: "lb",
              placeholder: "pounds",
            },
          },
          metric: {
            kilograms: {
              label: "kg",
              placeholder: "kg",
            },
          },
        },
        measurementSwitcher: "button",
      };
    },
    heightInputStyle(): HeightInputStyleProps {
      return {
        inputStyle: "w-[100px] p-4 rounded-xl",
        measurementIndicators: {
          imperial: {
            feet: {
              label: "ft",
              placeholder: "feet",
            },
            inches: {
              label: "in",
              placeholder: "inches",
            },
          },
          metric: {
            centimeters: {
              label: "cm",
              placeholder: "cm",
            },
          },
        },
        measurementSwitcher: "button",
      };
    },
  },
  methods: {
    updateAcceptTerms() {
      this.acceptTerms = true;

      // not every consultation has an agreement question at the end. For example the check-in consultation for levity
      // US does not have one
      const currentQuestion = this.getCurrentQuestion();
      if (currentQuestion.questionType === "AgreementQuestion") {
        currentQuestion.response = "true";
      }
    },
    getCurrentQuestion(): Question {
      return this.allQuestions[this.currentQuestionIndex];
    },
    getCurrentQuestionSection(): string | null {
      const maybeSection = window.location.href.split("#").pop();
      if (maybeSection?.indexOf("step_question_", 0) === 0) {
        return maybeSection;
      }
      return null;
    },
    getCurrentQuestionIndex(): number {
      return parseInt(this.getCurrentQuestionSection()?.split("_")?.pop());
    },
    showCurrentScreenBasedOnUrl() {
      const currentQuestionSection = this.getCurrentQuestionSection();
      if (currentQuestionSection) {
        this.currentQuestionIndex = this.getCurrentQuestionIndex();
        this.showNextButton = false;
        this.errorState = false;
        this.consultationStatus = "Questionnaire";
      } else {
        this.consultationStatus = "SplashScreen";
      }
    },
    synchronizeWithHistoryAPI(newNumberOfHistoryItems?: number, newURL?: string): void {
      // Update the local state value with the relevant value from history API state
      this.numberOfPreviousHistoryItems =
        typeof window?.history?.state?.numberOfPreviousHistoryItems === "number"
          ? window.history.state.numberOfPreviousHistoryItems
          : 0;

      if (newNumberOfHistoryItems) {
        this.numberOfPreviousHistoryItems = newNumberOfHistoryItems;
        window?.history?.pushState(
          {
            numberOfPreviousHistoryItems: this.numberOfPreviousHistoryItems,
          },
          "",
          newURL
        );
      } else {
        window?.history?.replaceState(
          {
            numberOfPreviousHistoryItems: this.numberOfPreviousHistoryItems,
          },
          ""
        );
      }
    },
    assembleSubmitPayload(): any {
      if (
        this.isCheckInConsultation ||
        this.isWeightLossInjectableSixMonthlyReviewCheckIn ||
        this.isWeightLossInjectableSideEffectsConsultation
      ) {
        return this.assembleCheckInSubmissionPayload();
      }

      return this.assembleRegularConsultationSubmissionPayload();
    },
    assembleCheckInSubmissionPayload(): any {
      return {
        subscriptionId: this.subscriptionId,
        treatmentTypeConsultation: this.treatmentTypeConsultation,
        responses: this.createQuestionResponses(),
      };
    },
    assembleRegularConsultationSubmissionPayload(): any {
      return this.createResponse();
    },
    handleSubmissionFailure(e): void {
      if (e?.response?.data?.redirectTo) {
        window.location.assign(e.response.data.redirectTo);
        return;
      }
      if (
        this.isCheckInConsultation ||
        this.isWeightLossInjectableSixMonthlyReviewCheckIn ||
        this.isWeightLossInjectableSideEffectsConsultation
      ) {
        this.handleCheckInSubmissionFailure();
        return;
      }

      this.handleRegularConsultationSubmissionFailure();
    },
    handleCheckInSubmissionFailure(): void {
      this.errorMessage = "Something went wrong when submitting your check-in - please contact customer support";
    },
    handleRegularConsultationSubmissionFailure(): void {
      window.location.href = `/consultations/failed?productCode=${this.productCode}`;
    },
    submitConsultation() {
      axios
        .post(this.submitUrl, this.assembleSubmitPayload(), {
          headers: { [this.csrfHeader]: this.csrf },
        })
        .then((response) => {
          window.location.assign(response.data.redirectTo);
        })
        .catch((e) => {
          this.handleSubmissionFailure(e);
        });
    },
    submit(): void {
      this.showRequired = true;
      this.updateAcceptTerms();

      const question = this.getCurrentQuestion();
      if (this.responseExtractors[question.questionType](question) === null) {
        return;
      }

      const valid = this.acceptTerms && Object.values(this.valid).every(Boolean);

      if (valid) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: "complete_consultation",
        });

        amplitudeEvent("Proceed Consultation", {
          ...this.analyticsData,
          "Consultation Type": this.treatmentTypeConsultation,
        });

        this.submitConsultation();
      }
    },
    triggerLiveChat(): void {
      amplitudeEvent("Consultation Start Screen LiveChat Opened", this.analyticsData);

      window.zE.activate();
    },
    updateValidation(id: number, value: boolean): void {
      this.valid[id] = value;
    },
    updateShowRequired(): void {
      this.showRequired = false;
    },
    createQuestionResponses(): { [key: number]: any } {
      const responses: { [key: number]: any } = {};
      this.allQuestions.forEach((question) => {
        const extractor = this.responseExtractors[question.questionType];
        if (extractor === undefined) {
          return;
        }
        const response = extractor(question);
        if (response) {
          response.questionType = question.questionType;
        }
        responses[question.id] = response;
      });

      return responses;
    },
    createResponse(): QuestionnaireResponse {
      const responses = this.createQuestionResponses();

      return {
        responses: responses,
        acceptTerms: this.acceptTerms,
        followUpRequestId: this.followUpRequestId,
        usShippingState: this.usShippingState,
      };
    },
    formatSectionName(sectionName: string) {
      const parts = sectionName.split(/([a-z])([A-Z])/);
      if (parts.length === 4) {
        return parts[0] + parts[1] + " " + parts[2] + parts[3];
      } else {
        return sectionName;
      }
    },
    // Only used for the ZipHealth consultation, so don't know if it would work fine with the UK version
    updateAnswer(question: Question, data: any) {
      this.latestAnswer = {
        question: question,
        data: data,
      };

      this.updateShowRequired();
    },
    start(): void {
      this.consultationStatus = "Questionnaire";
      this.showNextButton = false;
      this.errorState = false;

      const nextURL = window.location.href.split("#")[0] + "#step_question_" + this.currentQuestionIndex;

      this.synchronizeWithHistoryAPI(this.numberOfPreviousHistoryItems + 1, nextURL);

      amplitudeEvent("Start Consultation", {
        ...this.analyticsData,
        "Consultation Type": this.treatmentTypeConsultation,
      });
    },
    submitContact(): void {
      this.consultationStatus = "ComeBackLater";
    },
    prev(): void {
      if (this.numberOfPreviousHistoryItems > 0) {
        window.history.go(-1);
      } else {
        let prevURL;

        if (this.currentSectionIndex === 0 && this.currentQuestionIndex === 0) {
          if (this.shouldSkipSplashScreenDuringEdConsultation) {
            window.history.go(-2);
          } else {
            prevURL = window.location.href.split("#")[0];
            this.consultationStatus = "SplashScreen";
          }
        } else {
          if (this.currentQuestionIndex > 0) {
            this.currentQuestionIndex--;
          }

          prevURL = window.location.href.split("#")[0] + "#step_question_" + this.currentQuestionIndex;
        }

        this.synchronizeWithHistoryAPI(0, prevURL);
      }
    },
    submitStateQuestion(state: string): boolean {
      this.usShippingState = state;
      return this.next();
    },
    next(): boolean {
      const question = this.getCurrentQuestion();

      const questionType = question.questionType;

      // Legacy State question has id = -1 and is not actually a question
      if (question.id <= 0) {
        this.gotoNextQuestion();
        return true;
      }

      const RequiredFreeTextElement = document.getElementById("free-text-required");
      if (RequiredFreeTextElement && this.shouldShowStickyNextButton) {
        RequiredFreeTextElement.scrollIntoView({ behavior: "smooth" });
      }

      if (question.questionType === "ComorbiditiesQuestion") {
        this.recordComorbiditiesAnswer(question as IMultiSelectQuestion);
      } else {
        this.recordAnswer(question, this.responseExtractors[questionType]);
      }

      if (this.responseWarningExtractors[question.questionType](question) === false) {
        this.showRequired = true;
        return false;
      }

      this.showRequired = false;
      if (question.questionType === "BloodPressureQuestion" && question.recentReading === false) {
        window.location.href = "/consultations/blood-pressure-check-needed";
      }

      // Navigating
      if (this.responseExtractors[question.questionType](question) === null) {
        this.showRequired = true;
        return false;
      }

      this.showRequired = false;

      this.recordEvent(this.latestAnswer.question, this.latestAnswer.data);

      this.latestAnswer = {};

      if (question.redirectOnSubmit !== undefined && question.redirectOnSubmit !== null) {
        window.location.href = question.redirectOnSubmit;
        return false;
      }

      // On last question do not attempt to move to the next question
      if (this.onLastQuestion) {
        return true;
      }

      this.gotoNextQuestion();
      return true;
    },
    gotoNextQuestion() {
      this.currentQuestionIndex++;

      const nextURL = window.location.href.split("#")[0] + "#step_question_" + this.currentQuestionIndex;

      this.synchronizeWithHistoryAPI(this.numberOfPreviousHistoryItems + 1, nextURL);

      this.showCurrentScreenBasedOnUrl();
      window.scrollTo(0, 0);
    },
    updateNextButtonStatus(status: boolean, errorState = false) {
      this.showNextButton = status;
      this.errorState = errorState;
    },
    recordEvent(question: Question | undefined, data: any) {
      const responseData = data?.response || "";
      const responses = Array.isArray(responseData) ? [...responseData] : [responseData];

      const isQualified = responses.every((response) => {
        if (question?.questionType === "YesNoQuestion") {
          return (
            (question.expectYes && response.toLowerCase() === "yes") ||
            (!question.expectYes && response.toLowerCase() === "no")
          );
        }

        return question?.acceptableValues?.includes(response);
      });

      try {
        const event: any = {
          consultation: extractConsultation(),
          name: formatName(question),
          response: formatResponse(question?.questionType, data),
          qualified: isQualified,
        };

        if (data.diastolic) event.diastolic = parseFloat(data.diastolic);
        if (data.systolic) event.systolic = parseFloat(data.systolic);

        amplitudeEvent("Consultation Answer", event);
      } catch (e) {
        console.error(e.message, question, data);
      }
    },
    recordComorbiditiesAnswer(question: IMultiSelectQuestion) {
      const request = {
        selectedChoices: question.response,
      };
      return this.postToUrl("/consultations/comorbidities", request)
        .catch((error) => {
          console.log("Error while saving to the comorbidities endpoint: ", error);
        })
        .then(() => {
          return this.recordAnswer(question, this.responseExtractors["ComorbiditiesQuestion"]);
        });
    },
    isConsultationCompleteUpTo(question: number): boolean {
      return this.allQuestions.slice(0, question).every((q) => {
        if (q.questionType === "StateQuestion") {
          return this.usShippingState !== null;
        }
        if (q.questionType === "SimpleBmiQuestion") {
          return !!q.response?.height && !!q.response?.weight;
        }
        if (q.questionType === "WeightQuestion") {
          return !!q.response?.weight;
        }
        if (q.questionType === "BloodPressureQuestion") {
          return !!q.systolicRange && !!q.diastolicRange;
        }
        if (q.questionType === "CustomFreeTextMedicalQuestion") {
          return q.isResponseYes !== null;
        }
        if (q.questionType === "FreeTextMedicalQuestion") {
          return !(q.isTakingAnyMedicine === null || (q.isTakingAnyMedicine && q.isTakingContraindicated === null));
        }
        if (q.questionType === "PreviousMigraineTreatmentQuestion") {
          return !(
            q.hasTriedTriptans === null ||
            (q.hasTriedTriptans === true && (q.hasExperiencedRelief === null || q.hasExperiencedSideEffects === null))
          );
        }

        return !!q.response;
      });
    },
    restartConsultationIfUnansweredQuestions() {
      if (this.getCurrentQuestionSection() && !this.isConsultationCompleteUpTo(this.getCurrentQuestionIndex())) {
        console.error(
          `Consultation incomplete prior to question ${this.getCurrentQuestionIndex()}. Redirecting to start.`
        );
        window?.history?.replaceState(
          {
            numberOfPreviousHistoryItems: 0,
          },
          "",
          this.shouldSkipSplashScreenDuringEdConsultation || this.skipSplashScreen
            ? window.location.href.split("#")[0] + "#step_question_0"
            : window.location.href.split("#")[0]
        );
      }
    },
  },
});
</script>
